import React from "react";
import { Button, makeStyles, shorthands } from "@fluentui/react-components";
import { useNavigate } from "react-router";

const useStyles = makeStyles({
  page: {
    minHeight: "70vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "24px",
  },
  card: {
    width: "100%",
    maxWidth: "680px",
    backgroundColor: "#fff",
    ...shorthands.padding("28px"),
    ...shorthands.borderRadius("12px"),
    ...shorthands.border("1px", "solid", "#E6E6E6"),
    textAlign: "center",
  },
  title: {
    margin: 0,
    marginBottom: "10px",
    color: "#361936",
    fontFamily: "'Playfair Display', serif",
    fontSize: "30px",
    lineHeight: 1.2,
  },
  subtitle: {
    margin: 0,
    marginBottom: "8px",
    color: "#4A4450",
    fontFamily: "'Barlow', sans-serif",
    fontSize: "16px",
  },
  hint: {
    margin: 0,
    marginBottom: "22px",
    color: "#7A7480",
    fontFamily: "'Barlow', sans-serif",
    fontSize: "14px",
  },
});

const AccessDeniedPage: React.FC = () => {
  const styles = useStyles();
  const navigate = useNavigate();

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <h1 className={styles.title}>Kein Zugriff</h1>
        <p className={styles.subtitle}>
          Dein Konto hat keine Berechtigung für diesen Bereich.
        </p>
        <p className={styles.hint}>
          Bitte kontaktiere deinen Administrator, um Zugriff zu erhalten.
        </p>
        <Button
          appearance="primary"
          style={{
            minWidth: "220px",
            backgroundColor: "#F8AA00",
            color: "#361936",
            fontFamily: "'Barlow', sans-serif",
            fontWeight: 700,
          }}
          onClick={() => navigate("/")}
        >
          Zurück zum Dashboard
        </Button>
      </div>
    </div>
  );
};

export default AccessDeniedPage;
